import React from "react";
import {
  Box,
  Icon,
  Text,
  CircularProgress,
  CircularProgressLabel,
  VStack,
} from "@chakra-ui/react";
import { getIconForCategory } from "./utils";

const PackingListCard = ({
  packingList,
  selectedListId,
  setSelectedIdList,
  scrollToTop,
}) => {
  // Calculate the progress percentage
  const items = packingList.packing_list_items;
  const completedItems = items.filter((item) => item.completed);
  const progress = (completedItems.length / items.length) * 100;

  return (
    <Box
      p={4}
      border="1px solid"
      borderColor={selectedListId === packingList._id ? "#286328" : "gray.200"}
      borderRadius="xl"
      onClick={() => {
        setSelectedIdList(packingList._id);
        scrollToTop(); // 👈 scroll page to the top
      }}
      cursor="pointer"
      textAlign="center"
    >
      <CircularProgress
        value={progress}
        size="60px"
        color="#286328"
        thickness="4px"
      >
        <CircularProgressLabel>
          <Icon
            as={getIconForCategory(packingList.packing_category)}
            w={6}
            h={6}
            color={selectedListId === packingList._id ? "#286328" : "gray.600"}
          />
        </CircularProgressLabel>
      </CircularProgress>
      <VStack
        display="flex"
        alignItems="center"
        spacing={0}
        justifyContent="center"
        mt={2}
      >
        <Text fontWeight="bold" as="span">
          {packingList.packing_category}
        </Text>
        <Text fontSize="sm" as="span" color="gray.600">
          {packingList.packing_list_name}
        </Text>
      </VStack>
      <Text fontSize="xs" color="gray.500" textAlign="center">
        {completedItems.length}/{items.length}
      </Text>
    </Box>
  );
};

export default PackingListCard;
